import { render, staticRenderFns } from "./interview-quizzes-history.html?vue&type=template&id=015ee216&scoped=true&"
import script from "./interview-quizzes-history.js?vue&type=script&lang=js&"
export * from "./interview-quizzes-history.js?vue&type=script&lang=js&"
import style0 from "./interview-quizzes-history.scss?vue&type=style&index=0&id=015ee216&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ee216",
  null
  
)

export default component.exports